import { render, staticRenderFns } from "./guia.vue?vue&type=template&id=7a148962&"
import script from "./guia.vue?vue&type=script&lang=js&"
export * from "./guia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports